import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import { Redirect } from "react-router-dom";
import theme from "../../theme";
import CommonTable from "../table";
import CommonButton from "../button";
import Loading from "../loading";
import FormModal from "./modal";
import {
  getWithdrawalCategoriesAction,
  createWithdrawalCategoryAction,
  updateWithdrawalCategoryAction,
  deleteWithdrawalCategoryAction
} from "../../containers/dashboard/action";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    width: "100%",
    minHeight: "calc(100vh - 175px)",
    padding: "45px 90px",
    marginLeft: "220px",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .title": {
      color: theme.colors.Violet,
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      fontSize: "24px",
    },
  },
  headerName: {
    fontSize: "13px",
    fontFamily: theme.fontFamily.MARKPROHEAVY,
    opacity: "0.3",
    color: theme.colors.Violet,
  },
  Tab: {
    position: "relative",
    top: "10px",
    left: "-22px",
    cursor: "pointer",
    "& .tableTitle": {
      borderRadius: "10px 10px 0px 0px",
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      fontSize: "16px",
      color: theme.colors.DodgerBlue,
      cursor: "pointer",
      padding: "15px 25px",
      top: `50%`,
      left: `15%`,
      transform: `translate(-50%,-50%)`,
      position: "absolute",
    },
  },
  tableContainer: {
    marginTop: "30px",
  },
  currency: {
    fontSize: "8px",
    position: "relative",
    bottom: "3px",
    marginRight: "2px",
  },
  successTube: {
    color: "#22D559",
    fontSize: "10px",
    fontFamily: theme.fontFamily.MARKPROBOLD,
    borderRadius: "14px",
    backgroundColor: "#E4FDEC",
    textAlign: "center",
    padding: "2px 8px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  editLabel: {
    cursor: "pointer",
    color: theme.colors.DodgerBlue,
    marginRight: "10px",
    fontFamily: theme.fontFamily.MARKPROHEAVY,
  },
  deleteLabel: {
    cursor: "pointer",
    color: theme.colors.Pomegranate,
    fontFamily: theme.fontFamily.MARKPROHEAVY,
  },
}));


export default function WithdrawLimitCategory() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = React.useState(false)
  const [editId, setEditId] = React.useState(null)
  const [page, setPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState(1);
  const page_size = 10;

  const dashboardReducer = useSelector((state) => (state.dashboardReducer))

  const getWithdrawalLimitCategoriesActionMethod = React.useCallback(
    (filters = {}) => (dispatch(getWithdrawalCategoriesAction(filters))), [dispatch]
  );
  const deleteWithdrawalLimitCategoryActionMethod = React.useCallback((data) => (
    dispatch(deleteWithdrawalCategoryAction(data)), [dispatch]))


  useEffect(() => {
    if (!openModal) {
      getWithdrawalLimitCategoriesActionMethod({ page, page_size });
    }
  }, [openModal, getWithdrawalLimitCategoriesActionMethod, page, page_size]);

  useEffect(() => {
    const {
      withdrawalLimitCategories,
      createWithdrawalLimitCategorySuccess,
      updateWithdrawalLimitCategorySuccess,
      deleteWithdrawalLimitCategorySuccess,
      loading
    } = dashboardReducer;
    if (
      (createWithdrawalLimitCategorySuccess ||
        updateWithdrawalLimitCategorySuccess ||
        deleteWithdrawalLimitCategorySuccess) && !loading
    ) {
      getWithdrawalLimitCategoriesActionMethod({ page, page_size });
      setOpenModal(false)
    }
    if (withdrawalLimitCategories?.count) {
      setTotalPage(Math.ceil(withdrawalLimitCategories.count / page_size));
    }
  }, [dashboardReducer, page, page_size, getWithdrawalLimitCategoriesActionMethod]);

  useEffect(() => {
    if (
      dashboardReducer?.error?.length ||
      dashboardReducer?.deleteWithdrawalLimitCategoryError?.length
    ) {
      const ele = document.getElementsByClassName("error-container");
      if (ele && ele.length) ele[0].scrollIntoView(false);
    }
  }, [dashboardReducer]);

  return (
    <div className={classes.root}>
      <div className={classes.headerContainer}>
        <div className="title">Withdrawal Limit Categories</div>
        <div>
          <CommonButton
            type="button"
            text="Add Limit Categories"
            stylevariant="primary"
            onClick={() => {
              setOpenModal(true);
              setEditId(null);
            }}
            style={{ padding: "5px 40px" }}
            fontSize="18px"
            fontFamily={theme.fontFamily.MARKPROHEAVY}
          />
        </div>
      </div>
      {!openModal && dashboardReducer?.error?.length ? (
        <div className={"error-container"}>
          {dashboardReducer.error.map((each, index) => (
            <div key={index}>{each}</div>
          ))}
        </div>
      ) : !openModal && dashboardReducer?.deleteWithdrawalLimitCategoryError?.length ? (
        <div className={"error-container"}>
          {dashboardReducer.deleteWithdrawalLimitCategoryError.map((each, index) => (
            <div key={index}>{each}</div>
          ))}
        </div>
      ) : null}
      {!dashboardReducer?.loading ? (
        <>
          <div className={classes.tableContainer}>
            <CommonTable
              columns={[
                {
                  Header: "Name",
                  accessor: "name",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                },
                {
                  Header: "Limit",
                  accessor: "limit",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                },
                {
                  Header: "Description",
                  accessor: "description",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                },
                {
                  Header: "Action",
                  accessor: "id",
                  HeaderCell: (data) => {
                    return <div className={classes.headerName}>{data}</div>;
                  },
                  Cell: (data) => {
                    return (
                      <div className={classes.flexContainer}>
                        <div
                          className={classes.editLabel}
                          onClick={() => {
                            setOpenModal(true);
                            setEditId(data);
                          }}
                        >
                          Edit
                        </div>
                        <div
                          className={classes.deleteLabel}
                          onClick={() => {
                            deleteWithdrawalLimitCategoryActionMethod({ id: data });
                          }}
                        style={{ display: "none" }}
                        >
                          Delete
                        </div>
                      </div>
                    );
                  },
                },
              ]}
              data={dashboardReducer?.withdrawalLimitCategories?.data}
            />

            {dashboardReducer?.withdrawalLimitCategories?.data?.length ? (
              <div className={"pagination"}>
                <Pagination
                  page={page}
                  count={totalPage}
                  showFirstButton
                  showLastButton
                  onChange={(event, value) => {
                    setPage(value);
                  }}
                />
              </div>
            ) : null}
          </div>
        </>
      ) : null}
      {openModal && <FormModal
        openModal={openModal}
        editId={editId}
        onClose={() => {
          setOpenModal(false);
          setEditId(null);
          getWithdrawalLimitCategoriesActionMethod({ page, page_size })
        }}
      />}

    </div>
  );
}